// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"344":"74603ce4","375":"9162db57","938":"d77c632e"}[chunkId] + ".chunk.js";
};